import { getType } from '@reduxjs/toolkit';
import { call, put, takeLatest } from 'redux-saga/effects';

import { IMessagingApi } from '../../interfaces';
import { convertToError } from '../../utils';
import * as actions from './actions';

function* sendEmail(api: IMessagingApi, action: ReturnType<typeof actions.sendEmail>) {
  const { email } = action.payload;

  try {
    yield call(api.sendEmail, email, true);

    yield put(actions.sendEmailSucceeded());
  } catch (e) {
    yield put(actions.sendEmailFailed(convertToError(e)));
  }
}

export function* appSaga(api: IMessagingApi) {
  yield takeLatest(getType(actions.sendEmail), sendEmail, api);
}
